import React from 'react'
import "./color.css"

function RedE() {
    var x = localStorage.getItem("percentage energy")
    return (
        <div className = "red__background">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default RedE
